import { api } from './axios';

const url = '/OneSoul/formsDetails';

export interface IFormsDetails {
  formId: number;
  firstName: string;
  lastName: string;
  israeliId: string;
  createdAt: Date;
  statusTypeId: number;
  statusName: string;
  statusDate: Date;
}

export const getFormsDetails = async () => {
  const formsDetailsData = await api.get<IFormsDetails[]>(url);

  if (formsDetailsData.data) {
    return formsDetailsData.data;
  }
};
